import { render, staticRenderFns } from "./OtherConfigAddView.vue?vue&type=template&id=c1e56d6e&scoped=true&"
import script from "./OtherConfigAddView.vue?vue&type=script&lang=js&"
export * from "./OtherConfigAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e56d6e",
  null
  
)

export default component.exports